import { Component } from '@angular/core';
import { EdiOrderDetailComponent, EdiOrderItem } from 'gung-standard';
import { OttoOlsenEdiModalChangeLineComponent } from '../otto-olsen-edi-modal-change-line/otto-olsen-edi-modal-change-line.component';

@Component({
  selector: 'otto-olsen-edi-order-detail',
  templateUrl: './otto-olsen-edi-order-detail.component.html',
  styleUrl: './otto-olsen-edi-order-detail.component.scss',
  standalone: false
})
export class OttoOlsenEdiOrderDetailComponent extends EdiOrderDetailComponent {
  changeLineAndRevalidate(line: EdiOrderItem, index: number) {
    const modalRef = this.modalService.open(OttoOlsenEdiModalChangeLineComponent, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      backdrop: 'static'
    });
    modalRef.componentInstance.ediOrderId = this.orderData.id;
    modalRef.componentInstance.ediOrderItem = line;
    modalRef.componentInstance.index = index;
    modalRef.result.then(
      result => {
        if (result && result.response) {
          if (result.validate) {
            this.validateAgain();
          }
          this.gungModalService
            .openConfirmYesNoModal(undefined, 'Sucessfully changed line', { size: 'sm' }, 'OK', null)
            .then(_ => {});
        }
      },
      reason => {}
    );
  }

  isDataInColumnCausingError(item: any, column: string): boolean {
    switch (column) {
      case 'OO_ARTNR':
        return item.errors?.some(e => e.validator === 'OttoEdiItemIdValidator' && (e.error === 'OO.artnr er ugyldig' || e.error === 'OO.artnr og K.artnr er ugyldig'));
      case 'K_ARTNR':
        return item.errors?.some(e => e.validator === 'OttoEdiItemIdValidator' && (e.error === 'K.artnr er ugyldig' || e.error === 'OO.artnr og K.artnr er ugyldig'));
      case 'QUANTITY':
        return item.errors?.some(e => e.validator === 'EdiQuantityValidator' || e.validator === 'OttoEdiCorrectPackageSizeProductsValidator');
      case 'UNIT':
        return item.errors?.some(e => e.validator === 'OttoEdiSameUnitOfMeasureProductsValidator');
      default:
        return false;
    }
  }
}
